import Vue from "vue";
import Quasar, {
    QSkeleton,
    QTab,
    QTabs,
    QRouteTab,
    QScrollObserver,
    QPullToRefresh,
    QFooter,
    QAvatar,
    QSpace,
    QSeparator,
    QCardActions,
    QImg,
    QBadge,
    QBanner,
    QDialog,
    QLayout,
    QHeader,
    QToolbar,
    QToolbarTitle,
    QPageContainer,
    QPage,
    QTable,
    QTh,
    QTr,
    QTd,
    QMenu,
    QBtn,
    QCheckbox,
    QRadio,
    QOptionGroup,
    QSelect,
    QInput,
    QInnerLoading,
    QIcon,
    QBtnToggle,
    QDate,
    QPopupProxy,
    QTooltip,
    ClosePopup,
    LoadingBar,
    Notify,
    QChip,
    QInfiniteScroll,
    QItem,
    QItemSection,
    QItemLabel,
    QList,
    QCard,
    QCardSection,
    QFile,
    QToggle,
} from "quasar";

Notify.registerType("primary-notify", {
    color: "deep-purple-13",
    icon: "warning",
    textColor: "white",
});

Vue.use(Quasar, {
    components: {
        QSkeleton,
        QTab,
        QTabs,
        QRouteTab,
        QScrollObserver,
        QPullToRefresh,
        QFooter,
        QAvatar,
        QSeparator,
        QCardActions,
        QImg,
        QBadge,
        QBanner,
        QDialog,
        QLayout,
        QHeader,
        QToolbar,
        QToolbarTitle,
        QPageContainer,
        QPage,
        QBtn,
        QBtnToggle,
        QCard,
        QCardSection,
        QCheckbox,
        QDate,
        QFile,
        QIcon,
        QInput,
        QInnerLoading,
        QItem,
        QItemLabel,
        QItemSection,
        QList,
        QMenu,
        QOptionGroup,
        QPopupProxy,
        QRadio,
        QSelect,
        QSpace,
        QTable,
        QTd,
        QTh,
        QTooltip,
        QTr,
        QInfiniteScroll,
        QChip,
        QToggle,
    },
    config: {
        loadingBar: {
            size: "2px",
            skipHijack: true,
        },
    },
    directives: {
        ClosePopup,
    },
    plugins: {
        LoadingBar,
        Notify,
    },
});
